import { render, staticRenderFns } from "./IssueAdd.vue?vue&type=template&id=1b775b7c"
import script from "./IssueAdd.vue?vue&type=script&lang=js"
export * from "./IssueAdd.vue?vue&type=script&lang=js"
import style0 from "./IssueAdd.vue?vue&type=style&index=0&id=1b775b7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports